import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { FilterEmitterService } from '@finder/shared/services/filter-emitter-service/filter-emitter.service';
import { ViewportDetection } from '@finder/shared/services/viewport-detection/viewport-detection.service';
import { DateRange } from '@finder/features/calendars/calendars.interface';

@Component({
    selector: 'finder-sticky-bar',
    templateUrl: './sticky-bar.component.html',
    styleUrls: ['./sticky-bar.component.scss']
})
export class StickyBarComponent implements OnInit, AfterViewInit {

    @Input() labels: any;
    @Input() fiveDay: boolean;
    @Input() dateRange: DateRange;
    @Input() datePicker: any;
    @Input() shortDateString: string;

    @Output() datePickerModal = new EventEmitter<any>();
    @Output() mobileFilters = new EventEmitter<any>();

    isMobile = false;
    filtersCount = 0;

    private destroy$ = new Subject<void>();

    constructor(
        private filterEmitterService: FilterEmitterService,
        private viewportService: ViewportDetection,
    ) { }

    ngOnInit() {
        this.isMobile = this.viewportService.isMobile();

        this.filterEmitterService.watchFilterList()
            .pipe(
                debounceTime(50),
                takeUntil(this.destroy$)
            )
            .subscribe((filterList) => this.filtersCount = filterList.length);
    }

    ngAfterViewInit() {
        this.viewportService.onViewportResize()
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.isMobile = this.viewportService.isMobile();
            });
    }

    openDatePickerModal() {
        this.datePickerModal.emit(true);
    }

    openMobileFilters() {
        this.mobileFilters.emit(true);
    }

}
